// src/components/BilgilerSection.js
import React, { useState, useEffect } from 'react';
import './BilgilerSection.css';

const BilgilerSection = () => {
  /* ---------- STORAGE ---------- */
  const storedUser = JSON.parse(sessionStorage.getItem('user') || '{}');
  const token      = sessionStorage.getItem('authToken');

  /* ---------- STATE ---------- */
  const [info, setInfo] = useState({
    address:     storedUser.address    || '',
    phone:       storedUser.phone      || '',
    birth_date:  storedUser.birth_date || '',
    tc_no:       storedUser.tc_no      || '',
    new_password: '',
    new_password_confirm: ''
  });
  const [isEditingInfo, setIsEditingInfo] = useState(false);
  const [savingInfo,    setSavingInfo]    = useState(false);

  const [contact, setContact] = useState({
    id: undefined,
    name: '',
    phone: '',
    relationship: ''
  });
  const [isEditingContact, setIsEditingContact] = useState(false);
  const [savingContact,    setSavingContact]    = useState(false);

  /* ---------- FETCH USER'S EMERGENCY CONTACT ---------- */
  const fetchContact = async () => {
    try {
      const res = await fetch(
        `https://apiportal.mbsays.com/public/api/emergency-contacts?user_id=${storedUser.id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      );
      if (!res.ok) throw new Error(`Status ${res.status}`);
      const data = await res.json();
      // Eğer array geliyorsa user_id'yle eşleşeni bul, değilse direkt ata
      const record = Array.isArray(data)
        ? data.find(item => item.user_id === storedUser.id)
        : data.user_id === storedUser.id
          ? data
          : null;
      setContact(record || { id: undefined, name: '', phone: '', relationship: '' });
    } catch (err) {
      console.error("Acil durum bilgisi çekilirken hata:", err);
      setContact({ id: undefined, name: '', phone: '', relationship: '' });
    }
  };

  useEffect(() => {
    fetchContact();
  }, []);

  /* ---------- CHANGE HANDLERS ---------- */
  const handleInfoChange = e => {
    const { name, value } = e.target;
    setInfo(prev => ({ ...prev, [name]: value }));
  };
  const handleContactChange = e => {
    const { name, value } = e.target;
    setContact(prev => ({ ...prev, [name]: value }));
  };

  /* ---------- SAVE PERSONAL INFO ---------- */
  const saveInfo = async () => {
    if (info.new_password || info.new_password_confirm) {
      if (info.new_password.length < 6) {
        alert('Yeni şifre en az 6 karakter olmalı.');
        return;
      }
      if (info.new_password !== info.new_password_confirm) {
        alert('Yeni şifre ve tekrar eşleşmiyor.');
        return;
      }
    }

    setSavingInfo(true);
    try {
      const payload = {
        address:    info.address,
        phone:      info.phone,
        birth_date: info.birth_date,
        tc_no:      info.tc_no
      };
      if (info.new_password) {
        payload.password              = info.new_password;
        payload.password_confirmation = info.new_password_confirm;
      }

      const res = await fetch(
        `https://apiportal.mbsays.com/public/api/users/${storedUser.id}`,
        {
          method: 'PUT',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        }
      );
      const result = await res.json();
      if (!res.ok) throw new Error(result.message || 'Kayıt başarısız.');

      sessionStorage.setItem(
        'user',
        JSON.stringify({ ...storedUser, ...info })
      );

      setIsEditingInfo(false);
      setInfo(prev => ({
        ...prev,
        new_password: '',
        new_password_confirm: ''
      }));

      alert(info.new_password
        ? 'Şifreniz başarıyla değiştirildi.'
        : 'Bilgileriniz başarıyla güncellendi.'
      );
    } catch (err) {
      alert(err.message || 'Bilgi kaydederken hata oluştu');
    } finally {
      setSavingInfo(false);
    }
  };

  /* ---------- SAVE / UPDATE EMERGENCY CONTACT ---------- */
  const saveContact = async () => {
    setSavingContact(true);
    try {
      const isExisting = Boolean(contact.id);
      const endpoint   = isExisting
        ? `https://apiportal.mbsays.com/public/api/emergency-contacts/${contact.id}`
        : 'https://apiportal.mbsays.com/public/api/emergency-contacts';
      const method     = isExisting ? 'PUT' : 'POST';

      const res = await fetch(endpoint, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization:  `Bearer ${token}`
        },
        body: JSON.stringify({ user_id: storedUser.id, ...contact })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      const saved = { ...contact, ...data };
      setContact(saved);
      setIsEditingContact(false);
      alert('Acil durum kişisi başarıyla kaydedildi.');
    } catch (err) {
      alert(err.message || 'Acil durum kişisi kaydederken hata oluştu');
    } finally {
      setSavingContact(false);
    }
  };

  /* ---------- RENDER ---------- */
  return (
    <div className="bilgiler-section">
      <h2>Bilgiler</h2>
      <table className="bilgiler-table">
        <tbody>
          {/* KİŞİSEL BİLGİLER */}
          <tr>
            <th>Kişisel Bilgiler</th>
            <td>
              <strong>İsim Soyisim:</strong> {storedUser.name} {storedUser.surname}<br/>
              <strong>E-Posta:</strong> {storedUser.email}<br/>
              <strong>Pozisyon:</strong> {storedUser.position}<br/>
              <strong>LinkedIn:</strong>{' '}
              <a href={storedUser.linkedin} target="_blank" rel="noopener noreferrer">
                {storedUser.linkedin}
              </a><br/>
          {/* KİŞİSEL BİLGİLER  <strong>İzin Günü:</strong> {storedUser.vacation_days}<hr/> */}
              <strong>Adres:</strong>{' '}
              {isEditingInfo
                ? <input name="address" value={info.address} onChange={handleInfoChange} />
                : info.address
              }<br/>
              <strong>Telefon:</strong>{' '}
              {isEditingInfo
                ? <input name="phone" value={info.phone} onChange={handleInfoChange} />
                : info.phone
              }<br/>
              <strong>Doğum Günü:</strong>{' '}
              {isEditingInfo
                ? <input type="date" name="birth_date" value={info.birth_date} onChange={handleInfoChange} />
                : info.birth_date
              }<br/>
              <strong>TC No:</strong>{' '}
              {isEditingInfo
                ? <input name="tc_no" value={info.tc_no} onChange={handleInfoChange} />
                : info.tc_no
              }<br/>

              {isEditingInfo && (
                <>
                  <hr/>
                  <h4>Şifre Değiştir</h4>
                  <label>
                    Yeni Şifre:<br/>
                    <input
                      type="password"
                      name="new_password"
                      value={info.new_password}
                      onChange={handleInfoChange}
                    />
                  </label><br/>
                  <label>
                    Yeni Şifre (Tekrar):<br/>
                    <input
                      type="password"
                      name="new_password_confirm"
                      value={info.new_password_confirm}
                      onChange={handleInfoChange}
                    />
                  </label><br/>
                </>
              )}
              {isEditingInfo
                ? <button className="edit-button-person" onClick={saveInfo} disabled={savingInfo}>
                    {savingInfo ? 'Kaydediliyor…' : 'Kişisel Bilgileri Kaydet'}
                  </button>
                : <button className="edit-button-person" onClick={() => setIsEditingInfo(true)}>
                    Kişisel Bilgileri Düzenle
                  </button>
              }
            </td>
          </tr>

          {/* ACİL DURUM KİŞİSİ */}
          <tr>
            <th>Acil Durum Kişisi</th>
            <td>
              <strong>Ad-Soyad:</strong>{' '}
              {isEditingContact
                ? <input name="name" value={contact.name} onChange={handleContactChange} />
                : contact.name || <em>—</em>
              }<br/>
              <strong>Telefon:</strong>{' '}
              {isEditingContact
                ? <input name="phone" value={contact.phone} onChange={handleContactChange} />
                : contact.phone || <em>—</em>
              }<br/>
              <strong>Yakınlık:</strong>{' '}
              {isEditingContact
                ? <input name="relationship" value={contact.relationship} onChange={handleContactChange} />
                : contact.relationship || <em>—</em>
              }<br/>
              {isEditingContact
                ? <button className="edit-button" onClick={saveContact} disabled={savingContact}>
                    {savingContact ? 'Kaydediliyor…' : 'Acil Kişiyi Kaydet'}
                  </button>
                : <button className="edit-button" onClick={() => setIsEditingContact(true)}>
                    Acil Durum Kişisini Düzenle
                  </button>
              }
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default BilgilerSection;
